(ns frontend.view.components.timeline.entry.oppo-put-on-hold
  (:require [frontend.view.components.timeline.entry.declaration :as te]
            [frontend.view.components.timeline.entry.default-item :as default]
            [frontend.view.components.timeline.entry.utils :as utils]
            [common.localization :as loc]
            [clojure.string :as string]
            [frontend.zap-time :as ztime]
            [frontend.state.current-session :as session]))

(defmethod te/timeline-entry-view :op.oppo/put-on-hold [{entry :entry}]
  (let [body-generator (fn [entry]
                         (let [oppo (->> entry
                                         :audit/target
                                         (get @session/entities))
                               comment (:oppo/status-comment oppo)
                               on-hold-until (:oppo/on-hold-until oppo)
                               hold (ztime/long->formatted-date on-hold-until)]
                           [:div
                            (loc/tr :on-hold-until)
                            (str " " hold)
                            (when-not (string/blank? comment)
                              [:p (str "'" comment "' ")])]))]
    [default/timeline-item-view entry utils/oppo-named-title-generator body-generator default/timestamp-generator]))
